module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-2021-6.080e7e98.jpg";